import React, { useEffect }  from 'react';
import './App.css';
import JSONFormatter from './components/JSONFormatter';
import UUIDGenerator from './components/UUIDGenerator';
import TimestampConverter from './components/TimestampConverter';
import RegexTester from './components/RegexTester';
import DataBeautifier from './components/DataBeautifier';
import Base32Base64JAMEncoderDecoder from './components/Base32Base64JAMEncoderDecoder';
import APIEndpointTester from './components/APIEndpointTester';
import ImageConverter from './components/ImageConverter';
import ColorPicker from './components/ColorPicker';
import RegexCheatSheet from './components/RegexCheatSheet';
import FAQ from './components/FAQ'
import JWTDecoder from './components/JWTDecoder';
import { Helmet } from 'react-helmet';




function App() {


  // Function to handle smooth scrolling
  const handleScroll = (id) => {
    console.log(id)
    const element = document.getElementById(id);
    console.log(element)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="App">
      <header>

        <h1>Dev Toolkit Hub</h1>
        <p className="encoder-decoder" >Welcome to Dev Toolkit Hub, a comprehensive collection of tools crafted to simplify and accelerate your development tasks! Whether you’re a seasoned developer or just starting out, our tools are designed to handle a variety of needs, from encoding and decoding to testing APIs, and much more. Each component is user-friendly and robust, offering both efficiency and precision. Dive into our tools below to discover their unique functionalities:</p>
        <Helmet>
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "WebSite",
                "name": "Dev Toolkit Hub",
                "url": "https://yourwebsite.com",
                "description": "Your go-to site for developer tools."
              }
            `}
          </script>
          <title>DevToolkitHub - Essential Developer Tools for Encoding, Decoding, and Data Formatting</title>
          <meta
            name="description"
            content="DevToolkitHub offers a collection of online tools for developers, including JSON formatter, Base64 encoder/decoder, JAM encoder/decoder, API tester, image convertor, uuid generator and more. Easily transform and organize your data, improve workflow efficiency, and handle data encoding tasks with this free toolkit."
          />
          <meta
            name="keywords"
            content="Developer tools, JSON Formatter, Base64 encoder, Base64 decoder, image convertor, color generator, json formatter, jwt decoder, regex testing, regex cheat sheet, JAM encoder, data formatting, online toolkit, developer utilities"
          />
          <meta
            name="robots"
            content="index, follow"
          />
          <meta name="author" content="DevToolkitHub" />
        </Helmet>
        <nav>
          <ul>
            <li><a href="#Base32Base64" onClick={() => handleScroll('Base32Base64')}>Base32/Base64/JAM</a></li>
            <li><a href="#JSONFormatter" onClick={() => handleScroll('JSONFormatter')}>JSON Formatter</a></li>
            <li><a href="#DataBeautifier" onClick={() => handleScroll('DataBeautifier')}>Data Beautifier</a></li>
            <li><a href="#APIEndpointTester" onClick={() => handleScroll('APIEndpointTester')}>API Endpoint Tester</a></li>
            <li><a href="#RegexCheatSheet" onClick={() => handleScroll('RegexCheatSheet')}>Regex Cheat Sheet</a></li>
            <li><a href="#ImageConverter" onClick={() => handleScroll('ImageConverter')}>Image Converter</a></li>
            <li><a href="#ColorPicker" onClick={() => handleScroll('ColorPicker')}>Color Picker</a></li>
            <li><a href="#JWTDecoder" onClick={() => handleScroll('JWTDecoder')}>JWT Decoder</a></li>
            <li><a href="#UUIDGenerator" onClick={() => handleScroll('UUIDGenerator')}>UUID Generator</a></li>
            <li><a href="#TimestampConverter" onClick={() => handleScroll('TimestampConverter')}>Timestamp Converter</a></li>
            <li><a href="#RegexTester" onClick={() => handleScroll('RegexTester')}>Regex Tester</a></li>
          </ul>
        </nav>
      </header>

      <main id="main">
        <div id="main-div">
          <JSONFormatter  />
          <DataBeautifier  />
          <JWTDecoder  />
          <UUIDGenerator  />
          <TimestampConverter />
          <Base32Base64JAMEncoderDecoder  />
          <RegexTester />
          <APIEndpointTester  />
          <ImageConverter  />
          <ColorPicker  />
          <RegexCheatSheet  />
           <FAQ />
        </div>
      </main>

      <footer>
        <p>&copy; {new Date().getFullYear()} Dev Toolkit Hub. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
